import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import LoginPage from "./components/auth/LoginPage";
import AuthProvider from "./components/auth/AuthProvider";
import HomePage from "./components/HomePage.jsx";
import Incomes from "./components/incomes/IncomesList";
import Profile from "./components/profile/Profile.js";
import ProtectedRoute from "./mini_components/ProtectRoute";
import Withdraws from "./components/withdraws/Withdraws";
import WithdrawAuth from "./components/withdraws/WithdrawAuth";
import WithdrawDetail from "./components/withdraws//WithdrawDetail";
import NotFound from "./mini_components/NotFound";
import ChangeFixedPass from "./components/changePassword/ChangeFixedPass.js";
import EntryPage from "./components/auth/Index";
import OtpForgotPasswordPage from "./components/auth/OtpForgotPasswordPage";
import ConfirmNewPasswordPage from "./components/auth/ConfirmNewPasswordPage";
import TowStepOtpVerification from "./components/auth/TowStepOtpVerification";
import StatementsList from "./components/statements/StatementsList";
import ChangePasswordLayout from "./components/changePassword/ChangePasswordLayout";
import ChangeOLdPasswordPage from "./components/changePassword/ChangeOLdPasswordPage";
import VerifyOldPasswordPage from "./components/changePassword/VerifyOldPasswordPage";
import HealthCheck from "./components/HealthCheck";
import ChangeLogs from "./change-logs/index.js";
import WithdrawalTransferManager from "./components/money-transfer/WithdrawalTransferManager";
import MoneyTransferReqList from "./components/money-transfer/MoneyTransferReqList.jsx";
import WithdrawalsLayout from "./components/money-transfer/WithdrawalsLayout";
import WithdrawProvider from "./context/WithdrawContext.jsx";
import AccountLayout from "./components/AccontLayout.jsx";
import Teter from "./components/teter/TeterPage.jsx";

function App() {
  return (
    <Routes>
      {/* authentication */}
      <Route element={<AuthProvider />}>
        <Route path="/" element={<EntryPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/tow-step-otp-confirm"
          element={<TowStepOtpVerification />}
        />
        <Route
          path="/forgot-password-otp-confirm"
          element={<OtpForgotPasswordPage />}
        />
        <Route
          path="/confirm-new-password"
          element={<ConfirmNewPasswordPage />}
        />
      </Route>
      {/* //////////// */}

      {/* private */}
      <Route element={<ProtectedRoute />}>
        <Route path="/home" element={<HomePage />} />
        <Route path="/teter" element={<Teter />} />
        <Route path="/profile" element={<Profile />} />
        <Route element={<ChangePasswordLayout />}>
          <Route
            path="/verify-old-password"
            element={<VerifyOldPasswordPage />}
          />
          <Route
            path="/change-old-password"
            element={<ChangeOLdPasswordPage />}
          />
        </Route>
        <Route path="/change-fixed-pass" element={<ChangeFixedPass />} />
       

        <Route
          path="/withdrawals"
          element={
            <WithdrawProvider>
              <WithdrawalsLayout />
            </WithdrawProvider>
          }
        >
          <Route path="list" element={<MoneyTransferReqList />} />
          <Route path="transfer" element={<WithdrawalTransferManager />} />
        </Route>

      
       <Route  path="/account" element={<AccountLayout />}>
         <Route path="statements" element={<StatementsList />} />
         <Route path="withdraws" element={<Withdraws />} />
          <Route path="incomes" element={<Incomes />} />
       </Route>

        <Route path="/confirm-withdraw" element={<WithdrawAuth />} />
        <Route path="/withdraw-detail/:id" element={<WithdrawDetail />} />
      </Route>

      {/* //////// */}

      <Route path="/changelog" element={<ChangeLogs />} />

      <Route path="*" element={<NotFound />} />
      <Route path="/hc" element={<HealthCheck />} />
    </Routes>
  );
}

export default App;
